<template>
    <router-view class="border border-gray-400 rounded-3xl px-10 py-8"></router-view>
</template>

<script>
    export default {
        name: 'AccountVoucher'
    };
</script>
